/* Centerfaced — deferred behaviours for the header drawer + cart drawer.
   CF 3.0t Speed: moved out of inline <script>/<li> markup so every page's HTML is
   smaller (this file is cached once).

   1. Lazy country list: snippets/cf-country-list.liquid renders an empty
      <ul data-cf-lazy-countries> + a JSON <script> of countries. The list is built
      the first time the shopper touches/focuses/keys inside that localization form
      (synchronously, before the click that opens the panel), then clicks submit
      the form exactly like Shrine's LocalizationForm.onItemClick.
   2. checkoutLoad(): spinner on the cart-drawer checkout button (was inline).
   3. Cart upsell ADD: one-time document-level delegation (was inline). */
(function () {
  'use strict';

  /* ---------- 1. lazy country list ---------- */
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function buildCountryList(ul) {
    if (!ul || ul.dataset.cfBuilt) return;
    ul.dataset.cfBuilt = '1';
    var src = ul.previousElementSibling;
    var data = [];
    try { data = JSON.parse(src && src.hasAttribute('data-cf-countries') ? src.textContent : '[]'); } catch (e) { data = []; }
    var tpl = ul.dataset.cfText || '[country_name]';
    var cls = ul.dataset.cfLinkClass || 'disclosure__link';
    var flags = ul.dataset.cfFlags === 'true';
    var selected = ul.dataset.cfSelected || '';
    var html = '';
    for (var i = 0; i < data.length; i++) {
      var c = data[i];
      var iso = esc(c[0]), name = esc(c[1]), cur = esc(c[2]), sym = esc(c[3]);
      var active = c[0] === selected;
      var text = tpl
        .replace(/\[country_name\]/g, name)
        .replace(/\[country_code\]/g, iso)
        .replace(/\[currency_code\]/g, cur)
        .replace(/\[currency_symbol\]/g, sym);
      html += '<li class="disclosure__item" tabindex="-1"><a class="' + cls + (active ? ' disclosure__link--active' : '') +
        '" href="#"' + (active ? ' aria-current="true"' : '') + ' data-value="' + iso + '">' +
        (flags ? '<img src="https://flagcdn.com/w80/' + iso.toLowerCase() + '.png" width="20" height="15" loading="lazy" decoding="async" alt="' + name + '" class="localization-form-v2__image">' : '') +
        text + '</a></li>';
    }
    ul.innerHTML = html;
    ul.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[data-value]') : null;
      if (!a) return;
      e.preventDefault();
      var form = ul.closest('form');
      var input = form && form.querySelector('input[name="country_code"]');
      if (input) input.value = a.getAttribute('data-value');
      if (form) form.submit();
    });
  }

  function onSelectorIntent(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var form = t.closest('form.localization-form');
    if (!form) return;
    var ul = form.querySelector('ul[data-cf-lazy-countries]');
    if (ul) buildCountryList(ul);
  }
  ['pointerdown', 'touchstart', 'focusin', 'keydown'].forEach(function (ev) {
    document.addEventListener(ev, onSelectorIntent, { capture: true, passive: true });
  });
  // Shopify theme editor re-renders sections: rebuild lists that were already built.
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('ul[data-cf-lazy-countries][data-cf-built]').forEach(function (ul) {
      delete ul.dataset.cfBuilt; buildCountryList(ul);
    });
  });

  /* ---------- 2. cart drawer checkout spinner ---------- */
  window.checkoutLoad = window.checkoutLoad || function (e) {
    var clickedBtn = e && e.currentTarget;
    if (!clickedBtn) return;
    var scope = clickedBtn.closest('cart-drawer') || document;
    var tnc = scope.querySelector('tnc-chekcbox[id^="TNC-Checkbox-"]');
    if (tnc && tnc.dataset.checked != 'true') return;
    clickedBtn.classList.add('loading');
    var spinner = clickedBtn.querySelector('.loading-overlay__spinner');
    if (spinner) spinner.classList.remove('hidden');
    setTimeout(function () {
      if (document.location.pathname.includes('/checkout')) return;
      clickedBtn.classList.remove('loading');
      clickedBtn.disabled = false;
      if (spinner) spinner.classList.add('hidden');
    }, 8000);
  };

  /* ---------- 3. cart upsell ADD (delegated; survives js-contents re-renders) ---------- */
  if (!window.__cfCartUpsellBound) {
    window.__cfCartUpsellBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest && e.target.closest('[data-cf-upsell-add]');
      if (!btn) return;
      var row = btn.closest('.cf-cart-upsell__row');
      var sel = row && row.querySelector('[data-cf-upsell-variant]');
      var vid = sel ? sel.value : btn.getAttribute('data-vid');
      var box = btn.closest('[data-cf-cart-upsell]');
      var addUrl = (box && box.getAttribute('data-add-url')) || '/cart/add.js';
      var cartEl = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var body = { items: [{ id: parseInt(vid, 10), quantity: 1 }] };
      try {
        if (cartEl && cartEl.getSectionsToRender) {
          body.sections = cartEl.getSectionsToRender().map(function (s) { return s.id; });
          body.sections_url = window.location.pathname;
        }
      } catch (err) {}
      btn.disabled = true;
      btn.textContent = 'ADDING…';
      try { if (cartEl) cartEl.classList.add('cf-adding'); } catch (err) {}
      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); }).then(function (res) {
        if (res.status && res.status !== 200) throw new Error(res.description || 'add failed');
        if (cartEl && cartEl.renderContents) {
          cartEl.classList.remove('is-empty');
          cartEl.renderContents(res);
          cartEl.classList.remove('cf-adding');
        } else {
          window.location.reload();
        }
      }).catch(function () {
        try { if (cartEl) cartEl.classList.remove('cf-adding'); } catch (err) {}
        btn.disabled = false;
        btn.textContent = 'ADD';
      });
    });
  }
})();
